<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-row>
              <b-col
                cols="3"
                v-if="SHOW_QB_ESSAY_QUESTION === '1'"
              >
                <b-form-group
                  label-for="input-default"
                  label="Cấu trúc đề thi"
                >
                  <v-select
                    v-model="filter.qbExamStructureId"
                    placeholder="Cấu trúc đề thi"
                    :options="qbExamStructures"
                    :reduce="option => option.value"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="3"
              >
                <b-form-group
                  label-for="input-default"
                  label="Học phần"
                >
                  <v-select
                    v-model="filter.subjectId"
                    placeholder="Học phần"
                    :options="subjects"
                    :reduce="option => option.value"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="3"
                v-if="SHOW_QB_ESSAY_QUESTION === '1'"
              >
                <b-form-group
                  label="Số lượng đề thi"
                >
                  <b-form-input
                    v-model="countExam"
                    :step="1"
                    min="1"
                    type="number"
                    class="text-bold text-danger"
                    placeholder="Số lượng đề thi"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                class="text-left mt-auto"
              >
                <b-form-group>
                  <b-button
                    v-show="filter.subjectId && filter.qbExamStructureId && countExam > 0 && creatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    style="margin-right: 5px"
                    @click="onCreateExam"
                  >
                    <span class="text-nowrap text-right">Tạo đề thi</span>
                  </b-button>
                  <b-button
                    v-show="filter.subjectId"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="info"
                    style="margin-right: 5px"
                    @click="btnSearchClick"
                  >
                    <span class="text-nowrap text-right">
                      Danh sách đề thi
                    </span>
                  </b-button>
                  <b-button
                    v-show="creatable && SHOW_QB_ESSAY_QUESTION === '1'"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-modal.saveModal
                    variant="success"
                    style="margin-right: 5px"
                    @click="onCreateExamManually"
                  >
                    <span class="text-nowrap text-right">Tạo đề thi thủ công</span>
                  </b-button>
                  <b-button
                    v-show="creatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-modal.createExamCountQuestionModal
                    variant="info"
                    style="margin-right: 5px"
                    @click="onCreateExamManuallyByCountQuestion"
                  >
                    <span class="text-nowrap text-right">Tạo đề thi theo số câu hỏi</span>
                  </b-button>
                  <b-button
                    v-show="creatable && SHOW_QB_ESSAY_QUESTION === '0'"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-modal.createExamCountQuestionAndSetModal
                    variant="info"
                    style="margin-right: 5px"
                    @click="onCreateExamManuallyByCountQuestionAndSet"
                  >
                    <span class="text-nowrap text-right">Tạo đề thi theo số câu hỏi & bộ</span>
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-table
                  striped
                  hover
                  responsive
                  :per-page="filter.itemsPerPage"
                  :current-page="filter.currentPage"
                  :items="dataSources"
                  :fields="fields"
                >
                  <template #cell(action)="data">
                    <b-dropdown
                      right
                      variant="success"
                      no-caret
                      size="sm"
                      boundary="viewport"
                    >
                      <template #button-content>
                        <feather-icon
                          icon="MoreHorizontalIcon"
                          class="align-middle text-body"
                        />
                      </template>
                      <b-dropdown-item
                        v-show="data.item.manually && updatable"
                        v-b-modal.saveModal
                        variant="warning"
                        class="btn-icon"
                        size="sm"
                        @click="onEdit(data.item)"
                      >
                        <feather-icon icon="EditIcon" /> Chỉnh sửa thông tin
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-show="mixable"
                        v-b-modal.mixExamModal
                        variant="success"
                        class="btn-icon"
                        size="sm"
                        @click="onMix(data.item)"
                      >
                        <feather-icon icon="BookmarkIcon" /> Trộn đề thi
                      </b-dropdown-item>
                      <b-dropdown-item
                        variant="info"
                        class="btn-icon"
                        size="sm"
                        @click="listAnswers(data.item)"
                      >
                        <feather-icon icon="ListIcon" /> Danh sách câu hỏi
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-show="data.item.manually && SHOW_QB_ESSAY_QUESTION === '1'"
                        variant="success"
                        class="btn-icon"
                        size="sm"
                        @click="importQuestion(data.item)"
                      >
                        <feather-icon icon="CheckSquareIcon" /> Import câu hỏi
                      </b-dropdown-item>
                      <b-dropdown-item
                        variant="success"
                        class="btn-icon"
                        size="sm"
                        @click="listExamMix(data.item)"
                      >
                        <feather-icon icon="ListIcon" /> Danh sách đề trộn
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="isLaoCai"
                        variant="warning"
                        class="btn-icon"
                        size="sm"
                        @click="downloadPdfAnswers('docx', data.item)"
                      >
                        <feather-icon icon="DownloadIcon" /> File đáp án toàn mã đề
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="updatable"
                        variant="danger"
                        class="btn-icon"
                        size="sm"
                        @click="onUpdateStatus(data.item)"
                      >
                        <feather-icon icon="EditIcon" /> Duyệt đề thi
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="deletable"
                        variant="danger"
                        class="btn-icon"
                        size="sm"
                        @click="onDelete(data.item)"
                      >
                        <feather-icon icon="TrashIcon" /> Xóa đề thi
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
                </b-table>
              </b-col>

              <b-col cols="12">
                <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
                  <b-form-group
                    label="Hiển thị"
                    label-cols="4"
                    label-align="left"
                    label-size="sm"
                    label-for="sortBySelect"
                    class="text-nowrap mb-md-0 mr-1"
                  >
                    <b-form-select
                      id="perPageSelect"
                      v-model="filter.itemsPerPage"
                      size="sm"
                      inline
                      :options="itemsPerPageOptions"
                    />
                    <span class="ml-1">bản ghi/trang</span>
                  </b-form-group>

                  <!-- pagination -->
                  <div>
                    <b-pagination
                      v-model="filter.currentPage"
                      :total-rows="totalRows"
                      :per-page="filter.itemsPerPage"
                      first-number
                      last-number
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mb-0"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>
                  </div>
                </b-card-body>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
    <Save
      :data-form="currentDataSource"
      @succeed="onSucceed"
    />
    <CreateByCountQuestionSave
      :data-form="currentDataSource"
      @succeed="onSucceed"
    />
    <CreateByCountQuestionAndSetSave
      :data-form="currentDataSource"
      @succeed="onSucceed"
    />
    <MixExam
      :data-form="currentDataSource"
      @succeed="onSucceed"
    />
    <b-modal
      id="modal-exam_questions"
      ref="modal-exam_questions"
      centered
      size="xl"
      :title="`Danh sách câu hỏi cho đề thi: ${dataSendClass.name}`"
      :hide-footer="true"
      no-close-on-backdrop
    >
      <ExamQuestions :qb-exam-id="dataSendClass.id" />
    </b-modal>
    <b-modal
      id="modal-exam_mix"
      ref="modal-exam_mix"
      centered
      size="xl"
      :title="`Danh sách đề thi được trộn từ đề: ${dataSendClass.name}`"
      :hide-footer="true"
      no-close-on-backdrop
    >
      <ExamMixs :qb-exam-id="dataSendClass.id" />
    </b-modal>
    <b-modal
      id="modal_import_questions"
      ref="modal_import_questions"
      centered
      size="xl"
      :title="`Danh sách câu hỏi cho đề thi: ${dataSendClass.name}`"
      :hide-footer="true"
      no-close-on-backdrop
    >
      <ImportQuestion :qb-exam-id="dataSendClass.id" />
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BOverlay,
  BPagination,
  BRow,
  BTable,
} from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import vSelect from 'vue-select'
import { getUser } from '@/auth/utils'
import ExamQuestions from '@/views/exam-question/qb-exam/ExamQuestions.vue'
import Save from '@/views/exam-question/qb-exam/Save.vue'
import ImportQuestion from '@/views/exam-question/import-question/ImportQuestion.vue'
import { QB_EXAM_STATUSES, MIX_EXAMS } from '@/const/status'
import MixExam from '@/views/exam-question/qb-exam/MixExam.vue'
import ExamMixs from '@/views/exam-question/qb-exam/ExamMixs.vue'
import CreateByCountQuestionSave from '@/views/exam-question/qb-exam/create-exam-count-question/CreateByCountQuestionSave.vue'
import CreateByCountQuestionAndSetSave from '@/views/exam-question/qb-exam/create-exam-count-question-and-set/CreateByCountQuestionAndSetSave.vue'

export default {
  name: 'Index',
  directives: {
    Ripple,
  },
  components: {
    Save,
    CreateByCountQuestionSave,
    CreateByCountQuestionAndSetSave,
    ExamQuestions,
    ImportQuestion,
    MixExam,
    ExamMixs,
    BFormInput,
    BDropdownItem,
    BDropdown,
    BFormGroup,
    vSelect,
    BButton,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    BTable,
  },
  data() {
    return {
      isLoading: false,
      filterExport: {
        qbExamId: null,
        type: null,
      },
      user: getUser(),
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        subjectId: null,
        qbExamStructureId: null,
        code: null,
        name: null,
        status: null,
      },
      filterExamStructure: {
        currentPage: 1,
        itemsPerPage: 10,
        status: 1,
      },
      currentDataSource: undefined,
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      dataSendClass: {},
      countExam: 1,
      qbExamStructures: [],
      checkShow: false,
      SHOW_QB_ESSAY_QUESTION: 0,
      fields: [
        {
          label: 'Tên đề thi',
          key: 'name',
        },
        {
          label: 'Mã đề thi',
          key: 'code',
        },
        {
          label: 'Học phần',
          key: 'subjectName',
        },
        {
          label: 'Trạng thái',
          key: 'status',
        },
        {
          label: '',
          key: 'action',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      subjects: 'qbQuestion/subjects',
      qbExamStructureDate: 'qbExamStructure/dataSources',
      dataSources: 'qbExams/dataSources',
      totalRows: 'qbExams/totalRows',
      systemParameters: 'parameter/dataLists',
    }),
    isLaoCai() {
      return this.user.orgCode.includes('LCI')
    },
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.QB_QUESTION)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.QB_QUESTION)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.QB_QUESTION)
    },
    mixable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.QB_CRITERIA_MIX_EXAM)
    },
  },
  watch: {
    async resource() {
      await this.onLoad()
    },
    'filter.currentPage': async function () {
      if (this.filter.subjectId) {
        await this.getDataSourcesFromStore()
      }
    },
    'filter.itemsPerPage': async function () {
      if (this.filter.subjectId) {
        this.updateParams({ currentPage: 1 })
        await this.getDataSourcesFromStore()
      }
    },
  },
  async created() {
    await this.onLoad()
  },
  methods: {
    ...mapMutations({
      setDataSources: 'qbExams/SET_DATA_SOURCES',
    }),
    ...mapActions({
      getDataSources: 'qbExams/getDataSources',
      deleteDataSource: 'qbExams/deleteDataSource',
      getSubjects: 'qbQuestion/getSubjects',
      getExamStructureData: 'qbExamStructure/getDataSources',
      insertExam: 'qbExams/createDataSource',
      updateDataSource: 'qbExams/updateManually',
      getDownloadPdfAnswer: 'qbExams/getDownloadPdfAnswer',
      getSystemParameters: 'parameter/getAllData',
    }),
    getIsCorrect(id) {
      return MIX_EXAMS.find(status => status.value === id).label
    },
    async onLoad() {
      this.isLoading = true
      try {
        await Promise.all([
          this.getSubjects({ organizationId: getUser().orgId }),
          this.getExamStructureData(this.filterExamStructure),
          this.getSystemParameters(),
        ])
        this.qbExamStructures = this.qbExamStructureDate.map(item => ({
          value: item.id,
          label: item.name,
        }))
        this.SHOW_QB_ESSAY_QUESTION = this.systemParameters.find(item => item.code === 'SHOW_QB_ESSAY_QUESTION').value || 0
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
        this.setDataSources([])
      } finally {
        this.isLoading = false
      }
    },
    async btnSearchClick() {
      this.isLoading = true
      try {
        await this.getDataSourcesFromStore()
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    listAnswers(data) {
      this.dataSendClass = data
      this.$refs['modal-exam_questions'].show()
    },
    listExamMix(data) {
      this.dataSendClass = data
      this.$refs['modal-exam_mix'].show()
    },
    importQuestion(data) {
      this.dataSendClass = data
      this.$refs.modal_import_questions.show()
    },
    onCreateExamManually() {
      this.currentDataSource = undefined
    },
    onCreateExamManuallyByCountQuestion() {
      this.currentDataSource = undefined
    },
    onCreateExamManuallyByCountQuestionAndSet() {
      this.currentDataSource = undefined
    },
    async onCreateExam() {
      const examNum = this.countExam
      const subjectName = this.subjects.find(e => e.value === this.filter.subjectId).label
      this.$swal({
        title: `Bạn chắc chắn muốn tạo <span class="text-danger">${examNum}</span> đề thi theo học phần <span class="text-danger">${subjectName}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.insertExam({
              qbExamStructureId: this.filter.qbExamStructureId,
              subjectId: this.filter.subjectId,
              countExam: this.countExam,
            })
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'CheckIcon',
                    variant: 'success',
                  },
                })
                await this.getDataSourcesFromStore()
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            }
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    onEdit(dataSource) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = dataSource
      this.currentDataSource = rest
    },
    onMix(dataSource) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = dataSource
      this.currentDataSource = rest
    },
    onDelete(dataSource) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa đề thi <span class="text-danger">${dataSource.name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteDataSource(dataSource.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'CheckIcon',
                    variant: 'success',
                  },
                })
                try {
                  await this.getDataSourcesFromStore()
                } catch (e) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `[${e.code}] ${e.message}`,
                      icon: 'XCircleIcon',
                      variant: 'danger',
                    },
                  })
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            }
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    async downloadPdfAnswers(type, dataSource) {
      this.filterExport.type = type
      this.filterExport.qbExamId = dataSource.id
      const data = await this.getDownloadPdfAnswer(this.filterExport)
      const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }))
      window.open(url, '_blank')
    },
    onUpdateStatus(dataSource) {
      this.$swal({
        title: `Bạn chắc chắn muốn duyệt đề thi <span class="text-danger">${dataSource.name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            // eslint-disable-next-line no-param-reassign
            dataSource.status = 2
            const response = await this.updateDataSource(dataSource)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'CheckIcon',
                    variant: 'success',
                  },
                })
                try {
                  await this.getDataSourcesFromStore()
                } catch (e) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `[${e.code}] ${e.message}`,
                      icon: 'XCircleIcon',
                      variant: 'danger',
                    },
                  })
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            }
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getDataSourcesFromStore()
    },
    async getDataSourcesFromStore() {
      this.isLoading = true
      try {
        await this.getDataSources(this.filter)
        this.checkShow = this.dataSources.length <= 0
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getDataSourcesFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'name')) this.updateParams({ name: columnFilters.name })
      if (Object.hasOwn(columnFilters, 'code')) this.updateParams({ code: columnFilters.code })
      if (Object.hasOwn(columnFilters, 'status')) this.updateParams({ status: columnFilters.status })
      await this.getDataSourcesFromStore()
    },
    async onSucceed(subjectId) {
      this.filter.subjectId = subjectId
      await this.getDataSourcesFromStore()
    },
    getStatusName(id) {
      return QB_EXAM_STATUSES.find(status => status.value === id).label
    },
  },
}
</script>
